import { Injectable } from '@angular/core'
import { AccountAppGql, AccountAppPageGql, AppGql, DisconnectAccountInput } from '@papi/interfaces'
import { Apollo, gql } from 'apollo-angular'
import { merge } from 'rxjs'
import { map } from 'rxjs/operators'

const appAccountSchema = `{
        account
        appId
        partnerId
        environment
        name
        email
        country
        rentalsAmount
        createdAt
      }`

const GET_ACCOUNTS_QUERY = gql`
  query getAppAccounts(
    $appId: String!
    $limit: Float = 100
    $skip: Float = 0
    $sort: Float = -1
    $sortBy: String!
    $search: String
  ) {
    getAppAccounts(appId: $appId, limit: $limit, skip: $skip, sort: $sort, sortBy: $sortBy, search: $search) {
      data ${appAccountSchema}
      total
    }
  }
`

const DISCONNECT_ACCOUNT_MUTATION = gql`
  mutation ($input: DisconnectAccountInput!) {
    disconnectAccount(input: $input) {
      success
    }
  }
`

const CONNECTED_SUBSCRIPTION = gql`
  subscription($input: String) {
    connected(filter: $input) ${appAccountSchema}
  }
`

const DISCONNECTED_SUBSCRIPTION = gql`
  subscription($input: String) {
    disconnected(filter: $input) ${appAccountSchema}
  }
`

@Injectable()
export class AppAccountsService {
  constructor(private apollo: Apollo) {}

  fetchAccounts(
    app: Pick<AppGql, '_id' | 'partnerId'>,
    pagination: { limit: number; skip: number; sort: 1 | -1; sortBy: string },
    search: string
  ) {
    return this.apollo
      .query<{ getAppAccounts: AccountAppPageGql }>({
        query: GET_ACCOUNTS_QUERY,
        variables: {
          appId: app._id,
          limit: pagination.limit,
          // skip: 0,
          skip: pagination.skip,
          sort: pagination.sort,
          sortBy: pagination.sortBy,
          search,
        },
      })
      .pipe(
        // // FAKE data
        // map(({ data: { getAppAccounts: page } }) => ({
        //   data: {
        //     getAppAccounts: {
        //       total: 100,
        //       data: Array.from<AccountAppGql>({ length: pagination.limit }).map((_x, i) => ({
        //         ...page.data[0],
        //         email: `${page.data[0].email}#${pagination.skip + i}`,
        //       })),
        //     },
        //   },
        // })),
        map((res) => res.data.getAppAccounts)
      )
  }

  disconnectAccount(input: DisconnectAccountInput) {
    return this.apollo.mutate({
      mutation: DISCONNECT_ACCOUNT_MUTATION,
      variables: { input },
    })
  }

  listenForChanges(input?: string) {
    return merge(
      this.apollo
        .subscribe<{ connected: AccountAppGql }>({ query: CONNECTED_SUBSCRIPTION, variables: { input } })
        .pipe(map((res) => res.data)),
      this.apollo
        .subscribe<{ disconnected: AccountAppGql }>({ query: DISCONNECTED_SUBSCRIPTION, variables: { input } })
        .pipe(map((res) => res.data))
    )
  }
}
